/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateLineItemTier extends models.Tier {
    constructor() {
        super();
        this.setDiscriminator("CreateLineItemTier");
    }

    getFixupPrototypeFunction() { return CreateLineItemTier.fixupPrototype; }

    static newInstance(model: Partial<CreateLineItemTier>): CreateLineItemTier {
        let obj = Object.assign(new CreateLineItemTier(), model);
        CreateLineItemTier.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateLineItemTier>): CreateLineItemTier {
        if (!model) return null;
        return CreateLineItemTier.newInstance(<CreateLineItemTier> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateLineItemTier) {
        if (!obj) return;

        models.CreateLineItemTier.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateLineItemTier): boolean {
        if (models.Tier.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateLineItemTier.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Percentage of the tier
     */
    percentage: number;

}
